// getIsPreviewClear.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

import { PREVIEW_PRESET } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

/**
 * Select whether preview media should be clear (not blurred).
 * Blur is opt-in: only an explicit 'blurred' PREVIEW_PRESET blurs;
 * any other value — including a missing one (no rule matched) — is clear.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {boolean} Return true when preview media should be clear.
 */
const getIsPreviewClear = createSelector(
  state => getRemoteConfigData(state, PREVIEW_PRESET),
  previewPreset => previewPreset !== 'blurred'
);

export default getIsPreviewClear;
